export const mobileAppEn = {
  mobileAppPage: {
    title: "Mobile App - Next Phase",
    subtitle: "Native mobile app with offline capabilities, real-time notifications and field-optimized experience (available in the next project phase)",
    nextPhase: "Next Phase",
    iosRating: "iOS Rating",
    androidRating: "Android Rating",
    downloads: "Downloads",
    activeUsers: "Active Users",
    downloadTitle: "Download Sentinel Crop Mobile",
    iosAppStore: "iOS App Store",
    googlePlay: "Google Play",
    versionFeatures: "{{platform}} Version Features:",
    fullOffline: "Full offline functionality",
    cameraScan: "Camera-based crop scanning",
    gpsMapping: "GPS field mapping",
    pushNotifications: "Push notifications",
    biometricAuth: "Biometric authentication",
    appleWatch: "Apple Watch companion app",
    androidWidgets: "Android widgets for quick data entry",
    downloadFor: "Download for {{platform}}",
    mobilePreview: "Mobile App Preview",
    liveDemo: "Live Demo",
    tryDemo: "Try Interactive Demo",
    appFeatures: "App Features",
    mobileWorkflow: "Mobile Workflow",
    technicalSpecs: "Technical Specs",
    planned: "Planned",
    cropHealthScanner: "Crop Health Scanner",
    cropHealthScannerDesc: "Scan crops with AI-powered disease detection using device camera",
    gpsFieldMapping: "GPS Field Mapping",
    gpsFieldMappingDesc: "Precise parcel mapping and boundary detection using GPS",
    realTimeAlerts: "Real-time Alerts",
    realTimeAlertsDesc: "Push notifications for weather warnings and insurance claims",
    offlineMode: "Offline Mode",
    offlineModeDesc: "Access critical data and functions without internet connectivity",
    voiceCommands: "Voice Commands",
    voiceCommandsDesc: "Voice-activated data entry and field recording",
    dataSync: "Data Sync",
    dataSyncDesc: "Seamless synchronization with web platform when online",
    fieldDataCollection: "Field Data Collection",
    fieldDataCollectionDesc: "Capture photos, GPS coordinates, and field observations directly from your mobile device",
    offlineDataStorage: "Offline Data Storage",
    offlineDataStorageDesc: "All data is stored locally when offline, ensuring no loss of critical information",
    automaticSync: "Automatic Sync",
    automaticSyncDesc: "When connectivity returns, data automatically syncs with the cloud platform",
    realTimeAnalysis: "Real-time Analysis",
    realTimeAnalysisDesc: "Receive instant AI-powered insights and recommendations on your mobile device",
    iosRequirements: "iOS Requirements",
    androidRequirements: "Android Requirements",
    minimumVersion: "Minimum {{platform}} Version:",
    compatibleDevices: "Compatible Devices:",
    ramRequired: "RAM Required:",
    storageRequired: "Storage Required:",
    languages: "Languages:",
    offlineStorage: "Offline Storage:",
    developmentStack: "Development Stack",
    mobileFramework: "Mobile Framework",
    keyTechnologies: "Key Technologies",
    comingNextPhase: "Coming in Next Phase",
    comingNextPhaseDesc: "The mobile app will be available in the next project phase. Meanwhile, you can access all features from our web platform.",
    iosAppNextPhase: "iOS App (Next Phase)",
    androidAppNextPhase: "Android App (Next Phase)",
    accessWebPlatform: "Access Web Platform"
  }
};